import React from 'react';
import FirebaseAuthTest from '@/components/FirebaseAuthTest';
import SimpleLayout from '@/components/SimpleLayout';

const AuthTestPage = () => {
  return (
    <SimpleLayout pageTitle="Firebase Authentication Test">
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <FirebaseAuthTest />
      </div>
    </SimpleLayout>
  );
};

export default AuthTestPage;
